import { Box, Link, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import { RemediationTag, TAG_BASED_REMEDIATIONS } from '../../../../../common/enums/RemediationTag';
import { Remediation } from '../../../../../common/models/Remediation';
import { Interpolation } from '../../../../../config/i18n/components/Interpolation';
import { useMemo } from 'react';

type Props = {
  remediation: Remediation | null;
  specificTag: RemediationTag | null;
  sectionSpacing?: number;
};

export const RemediationDetails = ({ remediation, specificTag, sectionSpacing = 3 }: Props) => {
  const specificRemediation = useMemo(() => {
    if (!specificTag) {
      return null;
    }
    return TAG_BASED_REMEDIATIONS()[specificTag];
  }, [specificTag]);

  if (remediation === null && specificTag === null) {
    return null;
  }

  const remediationText = remediation?.getRemediation();
  const triage = remediation?.getTriage();
  const advice = remediation?.getAdvice();
  const link = remediation?.getLink();
  const linkText = link?.getText();
  const linkUrl = link?.getHref();

  return (
    <Stack className="instance-remediation" spacing={sectionSpacing}>
      {remediationText && (
        <Box>
          <Typography fontWeight={500} gutterBottom>
            {t('remediation')}
          </Typography>
          <Interpolation>{remediationText}</Interpolation>
        </Box>
      )}
      {triage && (
        <Box>
          <Typography fontWeight={500} gutterBottom>
            {t('triage')}
          </Typography>
          <Typography>{triage}</Typography>
        </Box>
      )}
      {advice && (
        <Box>
          <Typography fontWeight={500} gutterBottom>
            {t('specificRemediationAdvice')}
          </Typography>
          <Typography>{advice}</Typography>
        </Box>
      )}
      {link && (
        <Box>
          <Typography fontWeight={500} gutterBottom>
            {t('reference')}
          </Typography>
          {linkUrl ? (
            <Link href={linkUrl} target="_blank">
              {linkText}
            </Link>
          ) : (
            <Typography sx={{ fontStyle: 'italic' }}>{linkText}</Typography>
          )}
        </Box>
      )}
      {specificRemediation && (
        <Box>
          <Typography fontWeight={500} gutterBottom>
            {t('specificRemediation')}
          </Typography>
          <Interpolation>{specificRemediation}</Interpolation>
        </Box>
      )}
    </Stack>
  );
};
